/**
 * AWARD WINNERS STAY OFF THE SHOUT-OUT WALL UNTIL KIM POSTS THEM; SHOUT-OUTS
 * STAY ON IT FOR GOOD.
 *
 * Bobbie, 2026-09-29 early afternoon Central, verbatim: "we need to pull
 * things off the wall asap!!! or hide the wall until the update is made!!!",
 * "there are people getting on the wall and notifitiohns now that should not
 * until KIM puts them on the eall!", "we need to make a note that says hidden
 * from everyone except directors until update is fixed so that Kim isn't
 * confused when she sees the wall because she'll think everyone is seeing
 * it." Then, about 2:30pm: "Shoutouts can continue on the scroll for 7 days.
 * Everytime" and "But the awards should not go live until she posts on the
 * wall".
 *
 * About 3:55pm she withdrew the 7 days: "shoutouts stay foever on that month",
 * and asked which she meant, chose "Forever everywhere" (every shout-out stays
 * under its month and on All, for good).
 *
 * So the wall was opened to everyone again, every shout-out included, and every
 * award card (and the stars and pills built on them) showed only to a
 * Director until the awards update shipped.
 *
 * TURNED OFF (bug B7). Bobbie, 2026-10-04, DECISIONS 100, verbatim: "Yes, turn
 * them on"; and 2026-10-10 about 9:42am Central: "It's ok to post them now the
 * update is done", then about 9:20pm: "Families need to see it". Award cards
 * the green wall button put up now show to every active account, with
 * awardsHiddenFromNonDirectors() in shared/firestore.rules returning false in
 * the same commit. Posting stays Kim's step alone: only the wall button writes
 * a card, and the stamped-only filter (keepWallButtonCards in
 * lib/awardWinCard.ts, Bobbie 2026-09-29) is in the shared reads and on the
 * wall page for every viewer; wall-pause.test.mjs fails if this switch is
 * false while that filter is missing. Setting it back to true hides every
 * winner from everyone but a Director again (and the rules function with it).
 */
export const AWARDS_HIDDEN_UNTIL_POSTED = false;

/** The whole wall route is no longer hidden; kept for the gate and tests. */
export const SHOUTOUT_WALL_HIDDEN = false;

/**
 * How many days a shout-out shows on the wall, or null for no limit. Null since
 * Bobbie's "Forever everywhere" (above); the 7-day window of 2:30pm is withdrawn.
 * shoutoutStillOnWall and nextShoutoutExpiryMs stay so a later window is one
 * number, and are no-ops while this is null.
 */
export const SHOUTOUT_DAYS_ON_WALL: number | null = null;

export const WALL_HIDDEN_DIRECTOR_NOTE =
  'Award winners are hidden from everyone except Directors until the awards update is finished, even the ones you put on the wall. Shout-outs show to everyone.';

export const WALL_HIDDEN_NOTICE_TITLE = 'The Shout-out Wall is getting an update';
export const WALL_HIDDEN_NOTICE_BODY = 'It will be back soon.';

/** Who may see the wall route at all (everyone, unless the whole wall is hidden). */
export function canSeeShoutoutWall(role: string | null | undefined, hidden: boolean = SHOUTOUT_WALL_HIDDEN): boolean {
  return !hidden || role === 'director';
}

/** Who may see award cards, stars and pills: Directors only while awards are hidden. */
export function canSeeAwardWins(role: string | null | undefined, hidden: boolean = AWARDS_HIDDEN_UNTIL_POSTED): boolean {
  return !hidden || role === 'director';
}

const SHOUTOUT_MS_ON_WALL = SHOUTOUT_DAYS_ON_WALL === null ? null : SHOUTOUT_DAYS_ON_WALL * 24 * 60 * 60 * 1000;

/** A shout-out shows while it is younger than the window; always, with no window. */
export function shoutoutStillOnWall(whenMs: number | null, nowMs: number = Date.now()): boolean {
  if (whenMs === null || SHOUTOUT_MS_ON_WALL === null) return true;
  return nowMs - whenMs < SHOUTOUT_MS_ON_WALL;
}

/**
 * When the next shout-out still on the wall drops off, or null when none will
 * (always null with no window). The wall re-checks then, so a page left open
 * never keeps one past its time.
 */
export function nextShoutoutExpiryMs(
  whens: ReadonlyArray<number | null>,
  nowMs: number = Date.now()
): number | null {
  if (SHOUTOUT_MS_ON_WALL === null) return null;
  let next: number | null = null;
  for (const whenMs of whens) {
    if (whenMs === null) continue;
    const endMs = whenMs + SHOUTOUT_MS_ON_WALL;
    if (endMs > nowMs && (next === null || endMs < next)) next = endMs;
  }
  return next;
}

/**
 * Award announcements were paused with the awards: Make (her name) the MVP and
 * Finish announcing, and Write a congratulations post, could not be tapped
 * until the update shipped (Bobbie, same messages as above). TURNED OFF with
 * the awards (bug B7; DECISIONS 100, "Yes, turn them on"), here and in
 * netlify/functions/lib/wallNoticePause.mjs together. Setting it back to true
 * holds every month again.
 */
export const AWARD_ANNOUNCEMENTS_PAUSED = false;

/**
 * THE FIRST ROUND THAT ANNOUNCES. A round whose stored period is before this
 * one ('YYYY-MM', the key the round is stored under; 2026-11 recognizes
 * October 2026) had its winners put on the wall WHILE the awards were paused,
 * and its families and its Jr Staff MVP were never told. Lifting the pause
 * does not tell them now, weeks late: whether it should is Bobbie's call and
 * is on QUESTIONS-FOR-BOBBIE.md (raised 2026-10-25). So for those months the
 * wall step tells nobody, the congratulations posts stay locked, and the class
 * post gateway refuses one, exactly as while paused. Nothing is sent on
 * deploy either way: every announcement is a Director's tap.
 *
 * Her yes is one change: move this back to the earliest month she wants told,
 * here and nowhere else (the server reads this same constant).
 */
export const AWARD_ANNOUNCEMENTS_FIRST_PERIOD = '2026-11';

const PERIOD_KEY = /^\d{4}-(0[1-9]|1[0-2])$/;

/**
 * Is anything about this round's awards still held back (no family post, no
 * MVP notice)? Yes while the pause is on, for a round before
 * AWARD_ANNOUNCEMENTS_FIRST_PERIOD, and for a key that is not a month.
 */
export function awardAnnouncementsHeld(
  periodKey: string | null | undefined,
  paused: boolean = AWARD_ANNOUNCEMENTS_PAUSED,
  firstPeriod: string = AWARD_ANNOUNCEMENTS_FIRST_PERIOD
): boolean {
  if (paused) return true;
  if (typeof periodKey !== 'string' || !PERIOD_KEY.test(periodKey)) return true;
  return periodKey < firstPeriod;
}

/** The wall step's result line for a held round, once the pause itself is off. */
export const AWARD_HELD_PAST_RESULT_TEXT =
  'No family was posted to or notified: these winners went up while the awards were paused, and telling them is on hold until the studio decides.';

/** The wall step's confirm, families line, for a held round, once the pause itself is off. */
export const AWARD_HELD_PAST_CONFIRM_TEXT =
  'These winners went up while the awards were paused, so no family gets a congratulations post or a notification this time. Telling them is on hold until the studio decides.';

/** Said on the Director's wall step for a round put up while the awards were paused. */
export const AWARD_ANNOUNCEMENTS_HELD_PAST_NOTE =
  'These winners went up while the awards were paused, so their families and the Jr Staff MVP were not told. Telling them now is on hold until the studio decides.';

export const AWARDS_HIDDEN_WALL_STEP_NOTE =
  'For now, until the awards update is finished, winners you put on the wall show only to Directors, not families.';
export const AWARD_ANNOUNCEMENTS_PAUSED_NOTE =
  'Paused until the awards update is finished: nothing about the awards can be announced or sent to families from here yet.';
